export const AlertLevel = {
  ERROR: 'ERROR',
  INFO: 'INFO',
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING'
};

/* Default Error Messages. */
export const SESSION_HAS_EXPIRED = 'Session Has Expired';
export const NOT_FOUND =
  'There seems to be a problem with the requested resource. If the issue persists please try again later or contact customer care';
export const USER_LOGIN_ERROR = 'Your email and/or password is incorrect.';
export const GENERIC_ERROR_MESSAGE =
  'We’re sorry, our server encountered an internal error and was unable to complete your request. If this issue persists please try starting over or contact customer care.';
export const CHECKOUT_TWICE = 'You have checked out already, please return home.';

/**
 * Convert API/Server errors to user friendly messages.
 * This helper will also assume 403 errors are session timeouts and will throw
 * a "Session Ended" message to the user.
 *
 * @param error
 * @returns {*}
 */

type Error = {
  error: string;
  message: string;
  path: string;
  status: number;
  timestamp: string;
};

export const errorMessageHelper = (error: Error) => {
  if (!error) {
    throw new Error('errorMessageHelper: Missing arguments.');
  }

  if (error.message === CHECKOUT_TWICE) {
    return { error: CHECKOUT_TWICE, level: AlertLevel.ERROR };
  }

  try {
    switch (true) {
      case error.status === 400:
        return { error: error.message, level: AlertLevel.ERROR };
      case error.status === 403 &&
        (error.message === 'Access Denied' || (error.error === 'Forbidden' && error.path === '/user/login')):
        // Check 403 to see if it is failed used login.
        return { error: USER_LOGIN_ERROR, level: AlertLevel.ERROR };
      case error.status === 403:
        // Otherwise on 403, assume API session timeout and clear local user session info.
        return { error: SESSION_HAS_EXPIRED, level: AlertLevel.INFO };
      case error.status === 404:
        return { error: NOT_FOUND, level: AlertLevel.ERROR };
      case error.status === 500:
        // Internal Server Error
        return { error: GENERIC_ERROR_MESSAGE, level: AlertLevel.ERROR };
      default:
        return { error: error.error || error.message, level: AlertLevel.ERROR };
    }
  } catch (error) {
    // Unexpected error response format.
    return { error: GENERIC_ERROR_MESSAGE, level: AlertLevel.ERROR };
  }
};
